const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    credential: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {
       
        case 'CREDENTIAL_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                credential: action.payload
        };
      
        case 'CREDENTIAL_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                credential: action.payload,
            };
        case 'CREDENTIAL_CURRENT_ROLE':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                credential: action.payload
            };  
            
        case 'CREDENTIAL_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}
